import { Component, ViewChild } from '@angular/core';
import { ListCustomCell } from '@shared/modules/list/interfaces/list-custom-cell.interface';
import { ProjectStage } from '@shared/enums/project-stage.enum';
import { UIModule } from '@shared/modules/ui/ui.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'project-lose-cell',
  templateUrl: './project-lose-cell.component.html',
  standalone: true,
  imports: [UIModule, TranslateModule]
})
export class ProjectLoseCellComponent implements ListCustomCell {
  ProjectStage = ProjectStage;

  @ViewChild('template') template;
}
